module.exports = __webpack_public_path__ + "img/r6.7b72f6a4.png";